import React from 'react';
import Icon from '../Icon';
import { translate } from '../../Services/translation';

const QuantityInput = ({ quantity, setQuantity, packageSize }) => {
  const handleDecrease = () => {
    if (quantity > packageSize) {
      setQuantity(quantity - packageSize);
    }
  };

  const handleIncrease = () => {
    setQuantity(quantity + packageSize);
  };

  const handleQuantity = () => {
    if (!quantity && quantity !== 0) {
      setQuantity(packageSize);
      return;
    }

    const maxValue = Math.max(packageSize, parseInt(quantity));
    const roundedValue = Math.ceil(maxValue / packageSize) * packageSize;

    setQuantity(roundedValue);
  };

  return (
    <div className="quantity-input__wrapper">
      <button
        className="quantity-input__button"
        onClick={handleDecrease}
        aria-label={translate('buybutton.quantity.decrease.sc')}
        disabled={quantity == packageSize}
      >
        <Icon name="Minus" size={24} className="quantity-input__icon" />
      </button>
      <input
        className="quantity-input"
        type="number"
        value={quantity}
        min={packageSize}
        onChange={(e) => setQuantity(e.target.value)}
        onBlur={() => handleQuantity()}
        onKeyDown={(e) => e.key === 'Enter' && handleQuantity()}
      />
      <button
        className="quantity-input__button"
        onClick={handleIncrease}
        aria-label={translate('buybutton.quantity.increase.sc')}
      >
        <Icon name="Plus" size={24} className="quantity-input__icon" />
      </button>
    </div>
  );
};

export default QuantityInput;
